var React = require('react');

function Funk1 (props) {
    return React.createElement("svg",props,[React.createElement("clipPath",{"id":"a","key":0},React.createElement("path",{"clipRule":"evenodd","d":"m.199 17.19h499.801v220.931h-499.801z"})),React.createElement("g",{"transform":"translate(-.198802 -17.1901)","key":1},[React.createElement("path",{"d":"m.199 17.19h499.801v220.931h-499.801z","fill":"none","key":0}),React.createElement("g",{"clipPath":"url(#a)","key":1},React.createElement("path",{"d":"m13.91 61.641c32.107-54.305 443.728-51.682 463.215-30.006 23.557 26.202 38.734 165.267-14.497 171.444-41.131 4.772-120.603 25.464-139.691 30.014-21.647 5.159-298.374 16.387-315.076-30.014-6.81-18.92-15.575-104.864 6.049-141.438z","fill":"#fff","transform":"translate(.198802 .190126)"}))])]);
}

Funk1.defaultProps = {"width":"100%","preserveAspectRatio":"none","clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","viewBox":"0 0 500 221"};

module.exports = Funk1;

Funk1.default = Funk1;
